<template>
  <div class="card p-shadow-app" :style="{ position: 'relative' }"
  v-if="lgServiceOrdersWithoutPat > 0 || lgServiceOrdersToAccept > 0 || extranetServiceOrdersWithoutPat > 0"
  >
    <Loading :active.sync="loading" :isFullPage="false"></Loading>
    <H4>Alertas</H4>
    <div class="p-grid p-fluid dashboard p-jc-center">
      <div
        class="p-col-12 p-lg-12 cursor-pointer"
        v-on:click="$router.push('serviceOrders/lg')"
        v-if="lgServiceOrdersToAccept > 0"
      >
        <div class="card summary p-shadow-8">
          <span class="title"> Ordens de Serviço LG por Aceita </span>
          <span v-bind:class="['count', 'pats-red']">
            {{ lgServiceOrdersToAccept }}
          </span>
        </div>
      </div>
      <div
        class="p-col-12 p-lg-12 cursor-pointer"
        v-on:click="$router.push('serviceOrders/lg')"
        v-if="lgServiceOrdersWithoutPat > 0"
      >
        <div class="card summary p-shadow-8">
          <span class="title"> Ordens de Serviço LG sem PAT </span>
          <span v-bind:class="['count', 'pats-red']">
            {{ lgServiceOrdersWithoutPat }}
          </span>
        </div>
      </div>
      <div
        class="p-col-12 p-lg-12 cursor-pointer"
        v-on:click="$router.push('serviceOrders/hisense')"
        v-if="hisenseServiceOrdersWithoutPat > 0"
      >
        <div class="card summary p-shadow-8">
          <span class="title"> Ordens de Serviço HISENSE sem PAT </span>
          <span v-bind:class="['count', 'pats-red']">
            {{ hisenseServiceOrdersWithoutPat }}
          </span>
        </div>
      </div>
      <div
        class="p-col-12 p-lg-12 cursor-pointer"
        v-on:click="$router.push('serviceOrders/extranet')"
        v-if="extranetServiceOrdersWithoutPat > 0"
      >
        <div class="card summary p-shadow-8">
          <span class="title"> Ordens de Serviço Extranet sem PAT </span>
          <span v-bind:class="['count', 'pats-red']">
            {{ extranetServiceOrdersWithoutPat }}
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import loading from "vue-loading-overlay";
import serviceOrdersService from "../services/serviceOrders.service";
export default {
  name: "HomeAlerts",
  components: {
    Loading: loading,
  },
  data() {
    return {
      loading: true,
      lgServiceOrdersToAccept: 0,
      lgServiceOrdersWithoutPat: 0,
      hisenseServiceOrdersWithoutPat: 0,
      extranetServiceOrdersWithoutPat: 0
    };
  },
  async created() {
    if (this.can("acceptServiceOrder")) {
      this.lgServiceOrdersToAccept =
        await serviceOrdersService.countLgServiceOrdersToAccept();
    }
    if (this.can("createPatFromServiceOrder")) {
      this.lgServiceOrdersWithoutPat =
        await serviceOrdersService.countLgServiceOrdersWithoutPat();
    }
    if (this.can("createPatFromHisenseServiceOrder")) {
      this.hisenseServiceOrdersWithoutPat =
        await serviceOrdersService.countHisenseServiceOrdersWithoutPat();
    }
    if (this.can("seeExtranetServiceOrders")) {
      this.extranetServiceOrdersWithoutPat = await serviceOrdersService.countExtranetServiceWithoutPat()
    }
    return (this.loading = false);
  },
  methods: {},
};
</script>
<style>
.count {
  padding: 0px 14px !important;
}
.pats-green {
  background-color: #20d077;
}
.pats-red {
  background-color: #ef6262;
}
.pats-yellow {
  background-color: #f9c851;
}

.dashboard .summary .title {
  font-size: 15px;
}
.p-button-lg {
  color: #000 !important;
  font-size: 1.75rem !important;
  font-weight: bold !important;
}

.cursor-pointer {
  cursor: pointer;
}

.cursor-default {
  cursor: default;
}
</style>
